import moment from 'moment';

export default {
  namespaced: true,

  state: {
    activeMonth: '',
    activeYear: '',
    activeMonth2: '',
    activeYear2: '',
    startDate: '',
    endDate: '',
    startMonth: '',
    endMonth: '',
    startYear: '',
    endYear: '',
    dateChangeTriggered: '',
  },

  mutations: {
    SET_MONTH(state, payload) {
      state.activeMonth = payload;
    },
    SET_YEAR(state, payload) {
      state.activeYear = payload;
    },
    SET_MONTH_2(state, payload) {
      state.activeMonth2 = payload;
    },
    SET_YEAR_2(state, payload) {
      state.activeYear2 = payload;
    },
    SET_START_DATE(state, payload) {
      if (payload) {
        state.startDate = payload;
      } else {
        state.startDate = moment().startOf('month').format('MM/DD/YYYY');
      }
    },
    SET_END_DATE(state, payload) {
      if (payload) {
        state.endDate = payload;
      } else {
        state.endDate = moment().endOf('month').format('MM/DD/YYYY');
      }
    },
    SET_START_MONTH(state, payload) {
      state.startMonth = payload;
    },
    SET_END_MONTH(state, payload) {
      state.endMonth = payload;
    },
    SET_START_YEAR(state, payload) {
      state.startYear = payload;
    },
    SET_END_YEAR(state, payload) {
      state.endYear = payload;
    },
    DATE_CHANGE_TRIGGERED(state, payload) {
      state.dateChangeTriggered = payload;
    },

  },

  actions: {
    getYear({ commit }, payload) {
      commit('SET_YEAR', payload);
    },

    getMonth({ commit }, payload) {
      commit('SET_MONTH', payload);
    },

    getYear2({ commit }, payload) {
      commit('SET_YEAR_2', payload);
    },

    getMonth2({ commit }, payload) {
      commit('SET_MONTH_2', payload);
    },
    setStartDate({ commit }, payload) {
      commit('SET_START_DATE', payload);
    },
    setEndDate({ commit }, payload) {
      commit('SET_END_DATE', payload);
    },
    setStartMonth({ commit }, payload) {
      commit('SET_START_MONTH', payload);
    },
    setEndMonth({ commit }, payload) {
      commit('SET_END_MONTH', payload);
    },
    setStartYear({ commit }, payload) {
      commit('SET_START_YEAR', payload);
    },
    setEndYear({ commit }, payload) {
      commit('SET_END_YEAR', payload);
    },
    triggerDateChange({ commit }, payload) {
      commit('DATE_CHANGE_TRIGGERED', payload);
    },
  },

  getters: {
    activeMonth: state => state.activeMonth,
    activeYear: state => state.activeYear,
    activeMonth2: state => state.activeMonth2,
    activeYear2: state => state.activeYear2,
    startDate: state => state.startDate,
    endDate: state => state.endDate,
    startMonth: state => state.startMonth,
    endMonth: state => state.endMonth,
    startYear: state => state.startYear,
    endYear: state => state.endYear,
    dateChangeTriggered: state => state.dateChangeTriggered,
  },
};
